import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Divider, Paper, Typography } from '@mui/material';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useAtom } from 'jotai';
import useAPI from '../../../../api';
import ScopeAccordion from './EditorAccordion';
import DynamicItem from './DynamicItem';
import LandingPageDynEl from '../Templates/LandingPageDynEl';
import { lpgLinksAtom } from '../../../../Atoms';

const RightBar = function RightBar({
  editorType = '',
  handleClickDynamicElement = () => {},
}) {
  const intl = useIntl();
  const API = useAPI();

  const [lpgLinks, setLpgLinks] = useAtom(lpgLinksAtom);

  const [entities, setEntities] = useState({});

  useEffect(() => {
    API.getDynamicEntities(
      {},
      (res) => {
        setEntities(res);
      },
      () => {
        setEntities([]);
      }
    );
  }, []);

  useEffect(() => {
    if (editorType && editorType !== 'LANDING_PAGES')
      API.getAllLandingPages(
        (res) => {
          setLpgLinks(res);
        },
        () => {}
      );
  }, [editorType]);

  return (
    <Paper
      square
      elevation={2}
      sx={{
        height: '100%',
        width: '20%',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
      }}
    >
      <Typography variant="subtitle1" sx={{
        p: "16px"
      }}>
        {intl.messages.DYNAMIC_ELEMENTS}
      </Typography>
      <Divider variant="middle" />
      <div style={{ flexGrow: 1, overflow: 'auto', padding: '16px' }}>
        {Object.keys(entities).map((keyName, index) => (
          <ScopeAccordion
            key={keyName}
            id={`rightBar-accordion-${index}`}
            ParentTitleComponent={
              <Typography variant="subtitle1">
                {intl.messages[keyName?.toUpperCase()] ||
                  intl.messages.UNAVAILABLE}
              </Typography>
            }
            expandIcon={<ExpandMore />}
            items={entities[keyName]}
            listItemFunc={(element) =>
              DynamicItem({ element, onClick: handleClickDynamicElement })
            }
            uncontrolled
          />
        ))}

        <ScopeAccordion
          id="rightBar-accordion-landing-pages"
          ParentTitleComponent={
            <Typography variant="subtitle1">
              {intl.messages.LANDING_PAGES}
            </Typography>
          }
          expandIcon={<ExpandMore />}
          items={lpgLinks}
          listItemFunc={({ id, name }) =>
            LandingPageDynEl({ id, name, onClick: handleClickDynamicElement })
          }
          uncontrolled
        />
      </div>
    </Paper>
  );
};

RightBar.propTypes = {
  editorType: PropTypes.string,
  handleClickDynamicElement: PropTypes.func,
};

export default RightBar;
